import { message } from "antd";
import axios from "axios";
import { getErrorMessage } from "./getErrorMessage";

export const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      message.error("Session expired. Please log in again.");
    } else if (error.response && error.response.status === 403) {
      window.location.href = "/login";
      message.error("You are not authorized to access this page.");
    }
    return Promise.reject(error);
  },
);

export const getlog = async () => {
  try {
    const response = await API.get("/backend/log", {
      // params: {
      //   search: searchText,
      //   page: page,
      // },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// chatbot functionality
export const getConversasion = async () => {
  try {
    const response = await API.get("/chat/conversations", {
      // params: {
      //   search: searchText,
      //   page: page,
      // },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllMessage = async (id: any) => {
  try {
    const response = await API.get(`/chat/messages/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateResponse = async (data: {
  conversationId?: string;
  content: string;
  aiSettingId?: string | null;
}) => {
  try {
    const response = await API.post(`/chat/send`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createConversation = async () => {
  try {
    const response = await API.post(`/chat/create`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getChatSuggestions = async () => {
  try {
    const response = await API.get(`/chat/suggestions`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteConversation = async (id: string) => {
  try {
    const response = await API.delete(`/chat/conversations/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginuser = async (data: {
  employeeId: string;
  password: string;
}) => {
  try {
    const response = await API.post("/login", data);
    return response.data;
  } catch (error: any) {
    if (error?.code === "ERR_NETWORK" || error?.message === "Network Error") {
      throw new Error("Unable to connect to server. Please check if the backend is running.");
    }
    throw new Error(getErrorMessage(error) || "Login failed");
  }
};
export const registerUser = async (data: {
  username: string;
  email: string;
  password: string;
  mobileNo: string;
}) => {
  try {
    const response = await API.post("/register", data);
    return response.data;
  } catch (error: any) {
    // Preserve the full error response
    throw error; // Instead of throwing just the message
  }
};

export const addCustomer = async (formData: FormData) => {
  try {
    const response = await API.post("/backend/customers", formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCustomers = async (searchText: string, page: any) => {
  try {
    const response = await API.get("/backend/customers", {
      params: {
        search: searchText,
        page: page,
      },
    });
    // console.log("dffdfdsffsdf", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get all dashboard data in one API call
export const getDashboardData = async (params?: {
  salesFilterType?: "yearly" | "monthly" | "quarterly";
  salesYear?: number;
  salesMonth?: string;
  expensesFilterType?: "yearly" | "monthly" | "quarterly";
  expensesYear?: number;
  expensesMonth?: string;
  receiptsFilterType?: "yearly" | "monthly" | "quarterly";
  receiptsYear?: number;
  receiptsMonth?: string;
  taskDateFilterType?: "yearly" | "monthly" | "daily";
  taskDateYear?: number;
  taskDateMonth?: string;
  taskDateDay?: number;
}) => {
  try {
    const response = await API.get("/backend/dashboard", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

// Get only task stats data for filtering
// export const getTaskStatsData = async (params?: {
//   taskDateFilterType?: "yearly" | "monthly" | "daily";
//   taskDateYear?: number;
//   taskDateMonth?: string;
//   taskDateDay?: number;
// }) => {
//   try {
//     const response = await API.get('/backend/dashboard', {
//       params,
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching task stats data:", error);
//     throw error;
//   }
// };

export const getCustomersForReceipts = async (
  searchText: string,
  page: any,
  all: boolean,
) => {
  try {
    const response = await API.get("/backend/customers", {
      params: {
        search: searchText,
        page: page,
        all: all,
      },
    });
    // console.log("dffdfdsffsdf", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const exportReceiptsExcel = (params: {
  month?: string;
  method?: string;
  search?: string;
}) => {
  return API.get("/backend/receipts/export/excel", {
    params,
    responseType: "blob", // 🔴 IMPORTANT
  });
};

export const getCustomerByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/customers/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCustomer = async (id: string) => {
  try {
    const response = await API.delete(`/backend/customers/${id}/delete/`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const editCustomer = async (formData: FormData) => {
  try {
    const customerId = formData.get("id"); // Get ID from FormData
    if (!customerId) {
      throw new Error("Customer ID is missing!");
    }

    const response = await API.put(
      `/backend/customers/${customerId}/edit`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    // console.log("API Response:", response); // Debugging
    return response;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

export const updateCustomerOrder = async (orderedIds: string[]) => {
  try {
    const response = await API.post(
      "/backend/customers/update-order",
      {
        orderedIds: orderedIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error updating customer order:", error);
    throw error;
  }
};

export const deleteDeveloper = async (id: any, isDeleted: boolean) => {
  try {
    const response = await API.delete(`/backend/developers/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const hardDeleteDeveloper = async (id: any) => {
  try {
    const response = await API.delete(`/backend/developers/${id}/hard/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addDeveloper = async (formData: FormData) => {
  try {
    const response = await API.post("/backend/developers", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Ensure the content type is set for file uploads
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getallDeveloper = async (searchText: string, page: any) => {
  try {
    const response = await API.get("/backend/developers", {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallSoftDeletedDeveloper = async (
  searchText: string,
  page: any,
) => {
  try {
    const response = await API.get("/backend/softdeleted/developers", {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallDeveloperForTask = async (searchText: string, page: any) => {
  try {
    const response = await API.get("/backend/developers/fortask", {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDeveloperByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/developers/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDeveloper = async (data: FormData) => {
  try {
    const response = await API.put(
      `/backend/developers/${data.get("id")}/update`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDocumentImage = async (id: any, documentName: string) => {
  try {
    const response = await API.delete(
      `/backend/developers/${id}/delete/documents`,
      {
        data: { documentName }, // Sending the documentName as part of the request body
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addTask = async (data: FormData) => {
  try {
    const response = await API.post("/backend/tasks", data);
    return response;
  } catch (error) {
    console.error("Error in addTask API:", error);
    throw error;
  }
};

export const getallTask = async (
  searchText: string,
  page?: any,
  userId?: string,
  role?: string,
  isGroupBy?: boolean,
  devId?: any,
  filters?: {
    deadlineDate?: string[];
    status?: string[];
    projectId?: string;
    projectName?: string;
    page?: any;
    limit: any;
    ids?: string;
  },
  p0?: number,
) => {
  try {
    const response = await API.get("/backend/tasks", {
      params: {
        search: searchText,
        page,
        userId,
        role,
        isGroupBy,
        devId,
        deadlineDate: filters?.deadlineDate,
        status: filters?.status,
        projectId: filters?.projectId,
        projectName: filters?.projectName,
        pagetouse: filters?.page, // Use pageToUse from filters if provided
        limit: filters?.limit, // Use limit from filters if provided
        ids: filters?.ids, // ✅ Pass ids for filtering
        // taskPagination : filters?.taskPagination, // Add taskPagination to the params
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

export const updateDeveloperOrder = async (orderedIds: string[]) => {
  return API.post("/backend/developers/update-order", { orderedIds });
};

export const getAllTasksForTableView = async (
  searchText: string,
  page?: any,
  userId?: string,
  role?: string,
  isGroupBy?: boolean,
  filters?: {
    deadlineDate?: string[];
    status?: string[];
    projectId?: string;
    projectName?: string; // Add projectName to filters
    ids?: string; // Add ids to filters
  },
  p0?: number,
) => {
  try {
    const response = await API.get("/backend/tasks/task-tableview", {
      params: {
        search: searchText,
        page,
        userId,
        role,
        isGroupBy,
        deadlineDate: filters?.deadlineDate,
        status: filters?.status,
        projectId: filters?.projectId,
        projectName: filters?.projectName, // Pass projectName to backend
        ids: filters?.ids, // ✅ Pass ids to backend for filtering
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

export const getAllTasksForCardView = async (
  searchText: string,
  selectedDeveloper: any,
  role?: string,
) => {
  try {
    const response = await API.get("/backend/tasks/task-cardview", {
      params: {
        search: searchText,
        userId: selectedDeveloper,
        role: role,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

export const getTaskByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/tasks/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTask = async (id: any, isDeleted: boolean) => {
  try {
    const response = await API.delete(`/backend/tasks/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateTask = async (id: string, updatedData: any) => {
  try {
    const response = await API.put(`/backend/tasks/${id}/update`, updatedData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    console.error("Error updating task:", error);
    throw error;
  }
};

// export const transferTasks = async (id: string, targetId: string) => {
//   try {
//     const response = await API.put(`/backend/tasks/${id}/update`, {
//       targetId
//     }, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     return response;
//   } catch (error) {
//     console.error("Error updating task:", error);
//     throw error;
//   }
// };

export const transferTasks = async (fromUserId: string, toUserId: string) => {
  try {
    const response = await API.post("/backend/tasks/transfer", {
      fromUserId,
      toUserId,
    });
    return response;
  } catch (error) {
    console.error("Error transferring tasks:", error);
    throw error;
  }
};

export const deleteTaskPhoto = async (id: any) => {
  try {
    const response = await API.delete(`/backend/tasks/${id}/delete/photo`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addDesignation = async (data: any) => {
  try {
    const response = await API.post("/backend/designations", data);
    return response.data;
  } catch (error: any) {
    throw error.response.data.message;
  }
};

export const fetchDesignations = async (searchText: string, page: any) => {
  try {
    const response = await API.get("/backend/designations", {
      params: {
        search: searchText,
        page: page,
      },
    });
    // console.log("Fetched Designations:", response.data); // ✅ Debugging log
    return response.data; // ✅ Ensure it's an array
  } catch (error) {
    console.error("Error fetching designations:", error);
    return []; // ✅ Return empty array to prevent crashes
  }
};

export const deleteDesignation = async (id: any) => {
  try {
    const response = await API.delete(`/backend/designations/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getDesignationByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/designations/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDesignation = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/designations/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Roles Api

export const addRole = async (data: any) => {
  try {
    const response = await API.post("/backend/roles", data);
    return response.data;
  } catch (error: any) {
    throw error.response.data.message;
  }
};

export const getAllrole = async () => {
  try {
    const response = await API.get("/backend/roles");
    // console.log("Fetched Roles:", response.data); // ✅ Debugging log

    // Extract roles array from response object
    if (response.data && Array.isArray(response.data.roles)) {
      return response.data.roles;
    } else {
      console.error("Invalid API response format", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};

export const deleteRole = async (id: any) => {
  try {
    const response = await API.delete(`/backend/role/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getRoleByID = async (id: string) => {
  try {
    const response = await API.get(`/backend/role/${id}/edit`);
    // console.log("Fetched Role Data:", response.data);

    return response.data.role || response.data; // Ensure it returns the correct object
  } catch (error: any) {
    console.error("Error fetching role:", error);
    throw error.response?.data?.message || "Failed to fetch role";
  }
};

export const updateRole = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/role/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// project model apis

export const addProject = async (data: FormData) => {
  try {
    const response = await API.post("/backend/projects", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Upload failed";
  }
};

export const getallProject = async (
  searchText: string,
  page: any,
  tab: string = "all",
  pageSize: number = 10,
) => {
  try {
    const response = await API.get("/backend/projects", {
      params: {
        search: searchText,
        page: page,
        tab: tab,
        pageSize: pageSize,
        limit: pageSize,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProjectStats = async () => {
  try {
    const response = await API.get("/backend/projects/stats");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProjectOrder = async (orderedIds: string[]) => {
  try {
    const response = await API.post(
      "/backend/projects/update-order",
      {
        orderedIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating project order:", error);
    throw error;
  }
};
// ================= ARCHIVED PROJECTS =================
export const getAllArchivedProject = async (searchText: string, page: any) => {
  try {
    const response = await API.get("/backend/projects/archived", {
      params: {
        search: searchText,
        page: page,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallProjectForReceipts = async (
  searchText: string,
  page: any,
  all: boolean,
) => {
  try {
    const response = await API.get("/backend/projects", {
      params: {
        search: searchText,
        page: page,
        all: all,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProjectName = async () => {
  try {
    const response = await API.get("/backend/projects/name");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProject = async (id: any) => {
  try {
    const response = await API.delete(`/backend/projects/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const archiveProject = async (id: any) => {
  try {
    const response = await API.put(`/backend/projects/${id}/archive`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const restoreProject = async (id: any) => {
  try {
    const response = await API.put(`/backend/projects/${id}/restore`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProjectSummary = async (id: any, summaryId: any) => {
  try {
    const response = await API.delete(
      `/backend/projects/${id}/delete/summary/${summaryId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateProject = async (id: string, data: any, userId: string) => {
  try {
    const response = await API.put(
      `/backend/projects/${id}/update?userId=${userId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Update failed";
  }
};

export const getProjectByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/projects/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDocument = async (id: string, documentName: string) => {
  const response = await API.delete(
    `/backend/projects/${id}/delete/documents?documentName=${documentName}`,
  );
  return response.data;
};

// Roles & permission Api :-

export const getallRolePermissions = async (searchText: string) => {
  try {
    const response = await API.get("/backend/roles-permissions");
    // console.log("Raw API Response:", response); // Debugging

    if (!response || !response.data) {
      console.error("Invalid API response:", response);
      return { data: [] }; // Return a safe default value
    }

    return response.data;
  } catch (error: any) {
    console.error("Error fetching permissions:", error);

    // Handle potential API error structures
    if (error.response) {
      console.error("API Error Response:", error.response);
    }

    throw error;
  }
};

export const updateRolePermissions = async (id: string, data: any) => {
  try {
    const response = await API.put(
      `/backend/roles-permissions/${id}/update`,
      data,
      {},
    );
    return response.data;
  } catch (error) {
    console.error("Error in updateRolePermissions API:", error);
    throw error;
  }
};

// Menu Model Api :-

export const getallMenu = async (data: string) => {
  try {
    const response = await API.get("/backend/menus");
    // console.log("Get All Menu Response:", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createMenu = async (menuName: string, sequance: number) => {
  try {
    const response = await API.post("/backend/menus", { menuName, sequance });
    // console.log("Get All Menu Response:", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateMenu = async (
  id: string,
  data: { menuName: string; sequance?: number },
) => {
  try {
    const response = await API.put(`/backend/menu/${id}/update`, {
      data,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Update failed";
  }
};

export const fetchTasklog = async (
  taskId: any,
  page: any,
  userId: any,
  pageSize: number,
) => {
  try {
    const response = await API.get(`/backend/logs`, {
      params: {
        page: page,
        taskId,
        userId, // Include userId in the request parameters
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallReporterLoginUser = async (searchText: string) => {
  try {
    const response = await API.get("/backend/reporters");
    // console.log("API Response:", response);
    return response.data;
  } catch (error) {
    // console.error("Error fetching tasks:", error);
    throw error;
  }
};

// Attendance Model Api :-
export const addAttendance = async (data: any) => {
  try {
    const response = await API.post("/backend/attendances", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallAttendance = async (
  page: number,
  pageSize: any,
  month?: number,
  year?: number,
  date?: string,
  p0?: string,
) => {
  try {
    const response = await API.get("/backend/attendances", {
      params: {
        page,
        pageSize,
        date,
        month,
        year,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getallUserAttendance = async (
  userId: string | null,
  page: number | null,
  pageSize: any,
  day?: number | null,
  month?: number,
  year?: number,
  sortField?: any,
  sortOrder?: any,
) => {
  try {
    const response = await API.get("/backend/attendances/alluser-attendance", {
      params: {
        userId,
        page,
        pageSize,
        day,
        month,
        year,
        sortField,
        sortOrder,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllUserAttendanceExport = async (
  userId: string | null,
  day?: number | null,
  month?: number,
  year?: number,
) => {
  try {
    const response = await API.get(
      "/backend/attendances/alluser-attendance-export",
      {
        params: {
          userId,
          day,
          month,
          year,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAttendancebyID = async (id: any) => {
  try {
    const response = await API.get(`/backend/attendances/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAttendance = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/attendances/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAttendance = async (id: any) => {
  try {
    const response = await API.delete(`/backend/attendances/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addRequest = async (data: any) => {
  try {
    const response = await API.post("/backend/attendance-request", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// ======
export const getallRequest = async (searchText: string) => {
  try {
    const response = await API.get("/backend/attendance-request");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateRequest = async (id: string, data: any) => {
  try {
    const response = await API.put(
      `/backend/attendance-request/${id}/update`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// leave api

export const applyleave = async (data: any) => {
  try {
    const response = await API.post("/backend/leave", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const editleave = async (id: any, data: any) => {
  try {
    const response = await API.put(`/backend/leave/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLeaveById = async (id: any) => {
  try {
    const response = await API.get(`/backend/leave/${id}/edit`);
    // console.log("API Response:", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// In your API utils file
export const getallLeave = async (params: {
  search?: string;
  page?: number;
  status?: any;
  developerId?: string | null;
  role?: string;
  startDate?: string | null;
  endDate?: string | null;
}) => {
  try {
    const response = await API.get("/backend/leave/getall-leave", {
      params: {
        search: params.search,
        page: params.page,
        status: params.status,
        developerId: params.developerId,
        role: params.role,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleUserallLeave = async (params: {
  search?: string;
  page?: number;
  status?: any;
  startDate?: string | null;
  endDate?: string | null;
}) => {
  try {
    const response = await API.get("/backend/leave/getsingleall-leave", {
      params: {
        search: params.search,
        page: params.page,
        status: params.status,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLeave = async (id: any) => {
  try {
    const response = await API.delete(`/backend/leave/${id}/delete`);
    return response.data; // Make sure this returns a success status or message
  } catch (error) {
    console.error("Error deleting leave:", error);
  }
};

// miss punch
export const getUpdateAttandance = async (filters: {
  userId?: string | null;
  month?: number;
  year?: number;
  status: any;
  page?: number;
  limit?: number;
}) => {
  try {
    // Construct query parameters object
    const params: Record<string, any> = {};

    if (filters.userId) {
      params.userId = filters.userId;
    }
    if (filters.month !== undefined) {
      params.month = filters.month;
    }
    if (filters.year !== undefined) {
      params.year = filters.year;
    }
    if (filters.status !== undefined) {
      params.status = filters.status;
    }
    if (filters.page !== undefined) {
      params.page = filters.page;
    }
    if (filters.limit !== undefined) {
      params.limit = filters.limit;
    }

    const response = await API.get(
      "/backend/attendance-request/miss-match-record-request",
      {
        params: params,
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// profile

export const updateprofile = async (data: any) => {
  try {
    const response = await API.post(`/backend/user-profile/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getprofile = async (data: any) => {
  try {
    const response = await API.get(`/backend/user-profile`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// our time
export const addOvertime = async (data: any) => {
  try {
    const response = await API.post(`/backend/overtime`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getallovertime = async (
  searchText: any,
  page: any,
  pageSize: number,
  p0: { month: number; year: number; userId: string | undefined },
) => {
  try {
    const response = await API.get(`/backend/overtime`, {
      params: {
        search: searchText,
        page: page,
        pageSize: pageSize,
        month: p0.month,
        year: p0.year,
        userId: p0.userId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleUserAllOverTime = async (
  id: any,
  page: any,
  pageSize: number,
  p0: { month: number; year: number; search: any },
) => {
  try {
    const response = await API.get(`/backend/overtime/getSingleall-overtime`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getOvertimeById = async (id: any) => {
  try {
    const response = await API.get(`/backend/overtime/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const updateOvertime = async (id: any, data: any) => {
  try {
    const response = await API.put(`/backend/overtime/${id}/edit`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteOvertime = async (id: string) => {
  try {
    const response = await API.delete(`/backend/overtime/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addBoard = async (data: any) => {
  try {
    const response = await API.post(`/backend/board`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getallBoard = async (searchText: any, page: any) => {
  try {
    const response = await API.get(`/backend/board`, {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBoardOrder = async (orderedBoards: any[]) => {
  try {
    const response = await API.put("/backend/board/update", { orderedBoards });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getPermissions = async (): Promise<any[]> => {
  const token = localStorage.getItem("token");
  const response = await fetch("/api/permissions", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error("Failed to fetch permissions");

  const data = await response.json();
  return data.permissions || [];
};

// Holidays

export const createHoliday = async (data: any) => {
  try {
    const response = await API.post(`/backend/holidays`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllHolidays = async (params: {
  search?: string;
  page?: number;
  year?: number;
  type?: string;
}) => {
  try {
    const response = await API.get(`/backend/holidays`, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteHoliday = async (id: string) => {
  try {
    const response = await API.delete(`/backend/holidays/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getHolidayById = async (id: any, data: any) => {
  try {
    const response = await API.get(`/backend/holidays/${id}/edit`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateHoliday = async (id: any, data: any) => {
  try {
    const response = await API.put(`/backend/holidays/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getexportHoliday = async (searchText: string) => {
  try {
    const response = await API.get("/backend/holidays/export", {
      params: {
        search: searchText,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// utils/API.ts
export const bulkAddHoliday = async (formData: any) => {
  try {
    const response = await API.post("/backend/holidays/bulk", {
      holiday: formData,
    }); // ✅ key changed
    return response.data;
  } catch (error) {
    console.error("Error uploading Holidays:", error);
    throw error;
  }
};

//Get job Application by the sources

//Apply-Job
export const applyJob = async (data: FormData) => {
  try {
    const response = await API.post(`/job-apply`, data, {
      headers: {
        "Content-Type": "multipart/form-data", // optional, axios sets automatically
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getJobApplicationsSource = async (
  timeFilter?: "today" | "thisMonth" | "lastMonth" | "custom",
  startDate?: string,
  endDate?: string,
) => {
  try {
    const response = await API.get("/backend/job-applications/Analytics", {
      params: {
        timeFilter,
        startDate,
        endDate,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// job Application
export const createStatus = async (data: any) => {
  try {
    const response = await API.post(`/backend/job-applications/status`, {
      data,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

//get statuses
export const getStatus = async () => {
  try {
    const response = await API.get(`/backend/job-applications/status`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStatus = async (id: string, data: any) => {
  try {
    const response = await API.put(
      `/backend/job-applications/${id}/status`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStatus = async (id: string, data: any) => {
  try {
    const response = await API.delete(
      `/backend/job-applications/${id}/status`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDescription = async (id: any, descriptionId: any) => {
  try {
    const response = await API.delete(
      `/backend/job-applications/${id}/delete/description/${descriptionId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateJobApplicationStatus = async (id: string, data: any) => {
  try {
    const response = await API.put(
      `/backend/job-applications/${id}/status`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addJobApplication = async (data: any) => {
  try {
    const response = await API.post(`/backend/job-applications`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllJobApplications = async (params?: {
  search?: string;
  page?: number;
  limit?: number;
  status?: string[];
  timeFilter?: string;
  startDate?: string;
  endDate?: string;

  // ✅ new params
  experianceStart?: number;
  experianceEnd?: number;
  currentCTCMin?: number;
  currentCTCMax?: number;
  technology?: string;
  source?: string[]; // assuming array of source IDs
}) => {
  try {
    const response = await API.get(`/backend/job-applications`, {
      params: params || {}, // forward everything to backend
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getJobapplicationFromWebsite = async () => {
  try {
    const response = await API.get(`/backend/job-applications/website`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleJobApplication = async (id: any) => {
  try {
    const response = await API.get(`/backend/job-applications/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateJobApplication = async (id: any, data: any) => {
  try {
    const response = await API.put(
      `/backend/job-applications/${id}/update`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteJobApplication = async (id: string) => {
  try {
    const response = await API.delete(`/backend/job-applications/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteJobDocumentImage = async (
  id: string,
  documentName: string,
) => {
  try {
    const response = await API.delete(
      `/backend/job-applications/${id}/delete/documents`,
      {
        data: { documentName }, // required for DELETE
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getNofications = async () => {
  try {
    const response = await API.get(`/backend/notifications`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const updateNotification = async (id: string, read: boolean) => {
  try {
    const response = await API.put(`/backend/notifications/${id}/update`, {
      read,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating notification:", error);
    throw error;
  }
};

// campus off
export const fetchCampOffAttendance = async (userId: string, date: any) => {
  const formattedDate = date.format("YYYY-MM-DD");
  const response = await API.get(
    `/backend/attendances/camp-off/${userId}?date=${formattedDate}`,
  );
  return response.data;
};

export const addCampOffAttendance = async (payload: {
  userId: string;
  date: string;
  clockIn: string;
  clockOut: string;
  lunchStart: string;
  lunchEnd: string;
  status: string;
  reason: string;
}) => {
  const response = await API.post(`/backend/attendances/camp-off/add`, payload);
  return response.data;
};
export const getAllCampOffAttendance = async (userId: string, page: number) => {
  const response = await API.get(`/backend/attendances/camp-off`, {
    params: {
      userId,
      page,
    },
  });
  return response.data;
};

export const updateCampoffData = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/attendances/camp-off/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating camp-off data:", error);
    throw error;
  }
};
export const deleteCampoffData = async (id: string) => {
  try {
    const response = await API.delete(`/backend/attendances/camp-off/${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addSetting = async (formData: FormData): Promise<any> => {
  try {
    const response = await API.post("/backend/settings/add", formData);
    return response.data;
  } catch (error) {
    console.error("Error adding setting:", error);
    throw error;
  }
};

export const updateSetting = async (
  id: any,
  formData: FormData,
): Promise<any> => {
  try {
    const response = await API.put(`/backend/settings/${id}/update`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSettingData = async () => {
  try {
    const response = await API.get("/backend/settings");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getsetting = async () => {
  try {
    const response = await API.get("/backend/settings");
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Archive Leads
export const addArchive = async (id: string) => {
  try {
    const response = await API.put(`/backend/leads/archive/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const unArchive = async (id: string) => {
  try {
    const response = await API.put(`/backend/leads/unarchive/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getArchivedList = async (
  searchText: string,
  page: number,
  status?: string,
  timeFilter?: "today" | "thisMonth" | "lastMonth" | "custom",
  startDate?: string,
  endDate?: string,
  priority?: string,
) => {
  try {
    const response = await API.get(`/backend/leads/archived`, {
      params: {
        search: searchText,
        page,
        status,
        timeFilter,
        startDate,
        endDate,
        priority,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Tag Master
export const getAllTags = async () => {
  try {
    const response = await API.get(`/backend/tags`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createTag = async (data: any) => {
  try {
    const response = await API.post(`/backend/tags`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTag = async (id: string) => {
  try {
    const response = await API.delete(`/backend/tags/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTagById = async (id: any) => {
  try {
    const response = await API.get(`/backend/tags/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateTag = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/tags/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Expense Type Master
export const getAllExpenseType = async () => {
  try {
    const response = await API.get(`/backend/expense/type`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createExpenseType = async (data: any) => {
  try {
    const response = await API.post(`/backend/expense/type`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteExpenseType = async (id: string) => {
  try {
    const response = await API.delete(`/backend/expense/type/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getExpenseTypeById = async (id: any) => {
  try {
    const response = await API.get(`/backend/expense/type/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateExpenseType = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/expense/type/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//shift
// =============================
// Developer Shift Master
// =============================

// GET ALL SHIFT

// CREATE SHIFT
// CREATE SHIFT
export const createShift = async (data: any) => {
  const response = await API.post(`/backend/shift`, data);
  return response.data;
};

// GET ALL SHIFT  ⭐ ADD THIS
export const getAllShift = async (search = "") => {
  const response = await API.get(`/backend/shift?search=${search}`);
  return response.data;
};

// GET SHIFT BY ID
export const getShiftById = async (id: any) => {
  const response = await API.get(`/backend/shift/${id}`);
  return response.data;
};

// UPDATE SHIFT
export const updateShift = async (id: string, data: any) => {
  const response = await API.put(`/backend/shift/${id}`, data);
  return response.data;
};

// DELETE SHIFT
export const deleteShift = async (id: string) => {
  const response = await API.delete(`/backend/shift/${id}`);
  return response.data;
};

//LeadStatus
export const createLeadStatus = async (data: any) => {
  try {
    const response = await API.post(`/backend/rawdata/status`, { data });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const isDeveloperUser = () => {
  try {
    const raw = localStorage.getItem("authData");
    if (!raw) return false;

    const parsed = JSON.parse(raw);
    const role =
      parsed?.roleId ?? parsed?.user?.roleId ?? parsed?.user?.roleId?.roleId;

    const roleId = role?.roleId ?? role?.id ?? role;
    const roleName = role?.name ?? role?.roleName ?? role;

    if (typeof roleId === "number") return roleId === 2;
    if (typeof roleName === "string") return roleName.toLowerCase() === "developer";

    return false;
  } catch {
    return false;
  }
};

export const getLeadStatus = async () => {
  try {
    if (isDeveloperUser()) {
      return { success: true, data: [] };
    }

    const response = await API.get(`/backend/rawdata/status`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const updateLeadsStatus = async (id: string, data: any) => {
//   try {
//     const response = await API.put(`/backend/leads/${id}/status`, data);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const deleteLeadStatus = async (id: string, data: any) => {
  try {
    const response = await API.delete(`/backend/rawdata/${id}/status`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLeadStatus = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/rawdata/${id}/status`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const addFilter = async (data: any) => {
  try {
    const response = await API.post("/backend/rawdata/filter", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFilter = async () => {
  try {
    const response = await API.get(`/backend/rawdata/filter`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFilter = async (id: string, data: any) => {
  try {
    const response = await API.put(
      `/backend/rawdata/filter/${id}/update`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFilter = async (id: string) => {
  try {
    const response = await API.delete(`/backend/rawdata/filter/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

//RawData
export const addRawData = async (data: FormData) => {
  try {
    const response = await API.post("/backend/rawdata", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateRawData = async (id: any, data: FormData) => {
  try {
    const response = await API.put(`/backend/rawdata/${id}/update`, data, {
      headers: { "Content-Type": "multipart/form-data" }, // let Axios handle boundary
    }); // no headers override!
    return response;
  } catch (error) {
    console.error("Error updating Lead:", error);
    throw error;
  }
};

export const getRawDataById = async (id: any) => {
  try {
    const response = await API.get(`/backend/rawdata/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getRawDataLog = async (
  id: string,
  page: number = 1,
  pageSize: number = 10,
  search: string = "",
  type: string,
) => {
  try {
    const response = await API.get(`/backend/${id}/logs`, {
      params: { page, pageSize, search, type }, // pass query params
    });
    return response.data; // { logs, pagination }
  } catch (error) {
    throw error;
  }
};

// Instead of search?: string, accept a query object
export const getAllRawData = async (params?: {
  search?: string;
  page?: number;
  ids?: string[];
  limit?: number;
  status?: string;
  timeFilter?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    const response = await API.get(`/backend/rawdata`, {
      params: params || {}, // send all filters if provided
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllRawDataForPin = async (params?: {
  search?: string;
  page?: number;
  limit?: number;
  status?: string[];
  timeFilter?: string;
  startDate?: string;
  endDate?: string;
  sortField?: string;
  sortOrder?: string;
  source?: string[];
  sourceid?: string[];
  priority?: string[];
  country?: string[];
  owner?: string[];
  assignee?: string;
  tags?: string[];
  followupdate?: string;
  followupstartDate?: string;
  followupendDate?: string;
}) => {
  try {
    const response = await API.get(`/backend/rawdata`, {
      params: params || {}, // send all filters if provided
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQualifiedRawData = async () => {
  try {
    const response = await API.get("/backend/rawdata/qualified");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQualifiedRawDataTitles = async () => {
  try {
    const response = await API.get("/backend/rawdata/qualified-titles");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// pin api
export const addPinLead = async (leadCode: string) => {
  const res = await API.post("/backend/rawdata/add-pin", { leadCode });
  return res.data;
};

export const getPinnedLeads = async () => {
  const res = await API.get("/backend/rawdata/pin");
  return res.data.pinnedLeads;
};

export const deleteRawData = async (id: string) => {
  try {
    const response = await API.delete(`/backend/rawdata/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteRawDataSummary = async (id: any, summaryId: any) => {
  try {
    const response = await API.delete(
      `/backend/rawdata/${id}/delete/summary/${summaryId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const transferRawData = async (
  fromDeveloperId: string,
  toDeveloperId: string,
) => {
  try {
    // CRM #1: Use dedicated JSON transfer endpoint (the :id/update route uses multer)
    const response = await API.post("/backend/rawdata/transfer", {
      fromDeveloperId,
      toDeveloperId,
    });
    return response;
  } catch (error) {
    console.error("Error transferring raw data:", error);
    throw error;
  }
};

// leads

export const deleteLeadsSummary = async (id: any, summaryId: any) => {
  try {
    const response = await API.delete(
      `/backend/leads/${id}/delete/summary/${summaryId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

// export const addleads = async (formData: FormData) => {
//   try {
//     const response = await API.post("/backend/leads", formData);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const convertLeads = async (id: any) => {
//   try {
//     const response = await API.post(`/backend/leads/convert/${id}`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getleads = async (
//   searchText: string,
//   page: any,
//   status?: string,
//   date?: string
// ) => {
//   try {
//     const response = await API.get("/backend/leads", {
//       params: {
//         search: searchText,
//         page,
//         status,
//         date,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getleads = async (
//   searchText: string,
//   page: number,
//   status?: string,
//   timeFilter?: "today" | "thisMonth" | "lastMonth" | "custom",
//   startDate?: string,
//   endDate?: string,
//   priority?: string
// ) => {
//   try {
//     const response = await API.get("/backend/leads", {
//       params: {
//         search: searchText,
//         page,
//         status,
//         timeFilter,
//         startDate,
//         endDate,
//         priority
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getrawdataSource = async (params: {
  source?: string[];
  sourceid?: string[];
  priority?: string[];
  country?: string[];
  status?: string[];
  owner?: string[];
  tags?: string[];
  timeFilter?: "today" | "thisMonth" | "lastMonth" | "custom" | null;
  startDate?: string | null;
  endDate?: string | null;
  followupdate?: string | null;
  followupstartDate?: string | null;
  followupendDate?: string | null;
  page?: number;
}) => {
  try {
    const response = await API.get("/backend/rawdata/Analytics", {
      params, // Axios automatically serializes the object
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const getexportleads = async (searchText: string) => {
//   try {
//     const response = await API.get("/backend/leads/export", {
//       params: {
//         search: searchText,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getleadsById = async (id: any) => {
//   try {
//     const response = await API.get(`/backend/leads/${id}/edit`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const updateleads = async (formData: FormData) => {
//   try {
//     const id = formData.get("id"); // Get ID from FormData
//     if (!id) {
//       throw new Error("Lead ID is missing!");
//     }

//     const response = await API.put(`/backend/leads/${id}/update`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response;
//   } catch (error) {
//     console.error("Error updating Lead:", error);
//     throw error;
//   }
// };

// export const deleteleads = async (id: string) => {
//   try {
//     const response = await API.delete(`/backend/leads/${id}/delete`);
//     return response;
//   } catch (error) {
//     console.error(error);
//   }
// };

// export const bulkUploadleads = async (formData: any) => {
//   try {
//     const response = await API.post("/backend/leads/bulk", { leads: formData });
//     return response.data;
//   } catch (error) {
//     console.error("Error uploading leads:", error);
//     throw error;
//   }
// }

export const syncLeadsWithSheets = async (direction = "both") => {
  try {
    const response = await API.post("/backend/rawdata/sync", null, {
      params: { direction },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// export const updateDealStatus = async (id: string, data: any) => {
//   try {
//     const response = await API.put(`/backend/deals/${id}/status`, data);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const addDeals = async (formData: FormData) => {
//   try {
//     const response = await API.post("/backend/deals", formData); // No headers
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getAllDeals = async (
//   search: string = '',
//   page: number = 1,
//   status?: string,
//   timeFilter?: string, // "today" | "thisMonth" | "lastMonth" | "custom"
//   startDate?: any,     // moment or string
//   endDate?: any        // moment or string
// ) => {
//   try {
//     const response = await API.get('/backend/deals', {
//       params: {
//         search,
//         page,
//         status,
//         timeFilter: timeFilter || '',
//         startDate: startDate ? (typeof startDate === "string" ? startDate : startDate.format("YYYY-MM-DD")) : undefined,
//         endDate: endDate ? (typeof endDate === "string" ? endDate : endDate.format("YYYY-MM-DD")) : undefined,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getDealById = async (id: any) => {
//   try {
//     const response = await API.get(`/backend/deals/${id}/edit`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getexportDeals = async (search = '') => {
//   try {
//     const response = await API.get(`/backend/deals/export`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// }

// export const updateDeals = async (formData: FormData) => {
//   try {
//     const id = formData.get("id"); // Get ID from FormData
//     if (!id) {
//       throw new Error("Lead ID is missing!");
//     }
//     const response = await API.put(`/backend/deals/${id}/update`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response;
//   } catch (error) {
//     console.error("Error updating Deal:", error);
//     throw error;
//   }
// };
// export const deleteDeal = async (id: string) => {
//   try {
//     const response = await API.delete(`/backend/deals/${id}/delete`);
//     return response;
//   } catch (error) {
//     console.error(error);
//   }
// };

export const addCompany = async (formData: FormData) => {
  try {
    const response = await API.post("/backend/companies", formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllCompany = async (searchText: any, page: any) => {
  try {
    const response = await API.get("/backend/companies", {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getexportCompanies = async (searchText: any) => {
  try {
    const response = await API.get("/backend/companies", {
      params: {
        search: searchText,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompanyById = async (id: any) => {
  try {
    const response = await API.get(`/backend/companies/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompany = async (id: string) => {
  try {
    const response = await API.delete(`/backend/companies/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateCompany = async (id: any, formData: FormData) => {
  try {
    const response = await API.put(
      `/backend/companies/${id}/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error updating Company:", error);
    throw error;
  }
};

// Contacts

export const addContacts = async (formData: FormData) => {
  try {
    const response = await API.post("/backend/contacts", formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getContacts = async (params: {
  search?: string;
  page: number;
  limit?: number;
}) => {
  try {
    const response = await API.get("/backend/contacts", {
      params: {
        search: params.search,
        page: params.page,
        limit: params.limit,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getexportContacts = async (params?: { search?: string }) => {
  try {
    const response = await API.get("/backend/contacts/export", {
      params: {
        search: params?.search,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const importContacts = async (formData: FormData) => {
  try {
    const response = await API.post("/backend/contacts/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const pinContact = async (contactId: string) => {
  const response = await API.patch(`/backend/contacts/${contactId}/pin`);
  return response.data;
};

export const getContactsById = async (id: any) => {
  try {
    const response = await API.get(`/backend/contacts/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateContacts = async (formData: FormData) => {
  try {
    const id = formData.get("id");
    if (!id) {
      throw new Error("Contacts ID is missing!");
    }

    const response = await API.put(`/backend/contacts/${id}/update`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating Lead:", error);
    throw error;
  }
};

export const deleteContacts = async (id: string) => {
  try {
    const response = await API.delete(`/backend/contacts/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

// souce

export const addSource = async (data: any) => {
  try {
    const response = await API.post("/backend/sources", data);
    return response.data;
  } catch (error: any) {
    throw error.response.data.message;
  }
};

export const getAllSources = async (
  searchText: string,
  page: number,
  categories: string[] = [],
) => {
  try {
    const response = await API.get("/sources", {
      params: {
        search: searchText || undefined,
        page: page,
        categories:
          categories && categories.length > 0
            ? categories.join(",")
            : undefined,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sources:", error);
    return { sources: [], total: 0, page: 1, totalPages: 0 };
  }
};

export const getSourceByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/sources/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSource = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/sources/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteSource = async (id: any) => {
  try {
    const response = await API.delete(`/backend/sources/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

// calender routes

export const AddEvent = async (data: any) => {
  try {
    const response = await API.post("/backend/events", data);
    return response.data;
  } catch (error: any) {
    throw error.response.data.message;
  }
};

export const getEvents = async (searchText: string = "", page: any = 1) => {
  try {
    const response = await API.get("/backend/events", {
      params: {
        search: searchText,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    return [];
  }
};

export const deleteEvent = async (id: any) => {
  try {
    const response = await API.delete(`/backend/events/${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

//resignation

export const addResignation = async (data: any) => {
  try {
    const response = await API.post(`/backend/resignation`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSingleResignation = async (id: any) => {
  try {
    const response = await API.get(`/backend/resignation/${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getAllResignation = async () => {
  try {
    const response = await API.get(`/backend/resignation`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteResignation = async (id: any) => {
  try {
    const response = await API.delete(`/backend/resignation/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateResignation = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/resignation/${id}/edit`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteResignationSummary = async (id: any, summaryId: any) => {
  try {
    const response = await API.delete(
      `/backend/resignation/${id}/delete/summary/${summaryId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const deleteResignationDocument = async (
  id: string,
  documentName: string,
) => {
  const response = await API.delete(
    `/backend/resignation/${id}/delete/documents?documentName=${documentName}`,
  );
  return response.data;
};

export const updateTaskOrder = async (orderedIds: any[]) => {
  try {
    const response = await API.post(`/backend/tasks/update-order`, {
      orderedIds,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCalender = async () => {
  try {
    const response = await API.get(`/backend/calender/links`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCalender = async (data: {
  userId: string;
  link: string;
}) => {
  try {
    const response = await API.put(`/backend/calender/links`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllReports = async (params: {
  page?: number;
  limit?: number;
  year?: number;
  month?: number;
  day?: number;
  developerId?: string;
  status?: string;
}) => {
  try {
    const response = await API.get("/backend/reports", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReportsByUserId = async (
  userId: string,
  params: {
    page?: number;
    limit?: number;
    year?: number;
    month?: number;
    day?: number;
    status?: string;
  },
) => {
  try {
    const response = await API.get(`/backend/reports/${userId}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const saveDynamicQuery = async (payload: {
//   name: string;
//   conditions: {
//     field: string;
//     operator: string;
//     value: string;
//     combinator: "AND" | "OR";
//   }[];
// }) => {
//   try {
//     const response = await API.post("/backend/DynamicQuery/add", payload);
//     return response.data;
//   } catch (error) {
//     console.error("Error saving dynamic query:", error);
//     throw error;
//   }
// };

// export const getAllDynamicQueries = async () => {
//   try {
//     const response = await API.get("/backend/DynamicQuery/getAllquery");
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching dynamic queries:", error);
//     throw error;
//   }
// };
// export const runSavedQuery = async (conditions: any) => {
//   try {
//     const response = await API.post(`/backend/DynamicQuery`, { conditions });
//     return response.data;
//   } catch (error) {
//     console.error("Error running dynamic query:", error);
//     throw error;
//   }
// };

// export const updateDynamicQuery = async (id: string, updatedData: any) => {
//   try {
//     const response = await API.put(`/backend/DynamicQuery/${id}/update`, updatedData);
//     return response.data;
//   } catch (error) {
//     console.error("Error updating dynamic query:", error);
//     throw error;
//   }
// };

// Receipts api
export const addReceipts = async (data: any) => {
  try {
    const response = await API.post(`/backend/receipts`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllReceipts = async (page: any) => {
  try {
    const response = await API.get("/backend/receipts", {
      params: {
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllReceiptsForAmounts = async (page: any, all: boolean) => {
  try {
    const response = await API.get("/backend/receipts", {
      params: {
        page: page,
        all: all,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateReceipts = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/receipts/${id}/update`, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Update failed";
  }
};

export const getReceiptsByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/receipts/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLastReceiptNumber = async () => {
  try {
    const response = await API.get("/backend/receipts/last-number");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteReceipts = async (id: any) => {
  try {
    const response = await API.delete(`/backend/receipts/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getReceiptsLog = async (
  id: string,
  page: number = 1,
  pageSize: number = 10,
  search: string = "",
  type: string,
) => {
  try {
    const response = await API.get(`/backend/${id}/receipts-logs`, {
      params: { page, pageSize, search, type }, // pass query params
    });
    return response.data; // { logs, pagination }
  } catch (error) {
    throw error;
  }
};

// Invoice api
export const addInvoice = async (data: any) => {
  try {
    const response = await API.post(`/backend/invoice`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllInvoice = async (
  page: any,
  all: boolean,
  searchText: string = "",
  selectedMonth?: string,
  selectedYear?: string,
) => {
  try {
    const response = await API.get("/backend/invoice", {
      params: {
        page: page,
        all: all,
        search: searchText,
        month: selectedMonth,
        year: selectedYear,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLastInvoiceNumber = async () => {
  try {
    const response = await API.get("/backend/invoice/last-number");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const auditInvoiceWithAI = async (data: any) => {
  try {
    const response = await API.post("/backend/invoice/ai-audit", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInvoice = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/invoice/${id}/update`, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Update failed";
  }
};

export const getInvoiceByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/invoice/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInvoice = async (id: any) => {
  try {
    const response = await API.delete(`/backend/invoice/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getInvoiceLog = async (
  id: string,
  page: number = 1,
  pageSize: number = 10,
  search: string = "",
  type: string,
) => {
  try {
    const response = await API.get(`/backend/${id}/invoice-logs`, {
      params: { page, pageSize, search, type }, // pass query params
    });
    return response.data; // { logs, pagination }
  } catch (error) {
    throw error;
  }
};

export const sendInvoiceEmail = async (
  invoiceId: string,
  toEmail?: string,
  ccEmail?: string,
  reminderType?: string,
) => {
  const response = await API.post("/backend/invoice/send-email", {
    invoiceId,
    toEmail,
    ccEmail,
    reminderType,
  });

  return response.data;
};

//AMC Maintenance API
// CREATE AMC
export const createAmc = async (data: any) => {
  const response = await API.post(`/backend/amc-maintenance`, data);
  return response.data;
};

// GET ALL AMC (Updated for Search)
export const getAllAmc = async (search = "") => {
  const response = await API.get(`/backend/amc-maintenance?search=${search}`);
  return response.data.data;
};

// GET AMC BY ID
export const getAmcById = async (id: string) => {
  const response = await API.get(`/backend/amc-maintenance/${id}`);
  return response.data;
};

// UPDATE AMC
export const updateAmc = async (id: string, data: any) => {
  const response = await API.put(`/backend/amc-maintenance/${id}`, data);
  return response.data;
};

// DELETE AMC
export const deleteAmc = async (id: string) => {
  const response = await API.delete(`/backend/amc-maintenance/${id}`);
  return response.data;
};

// Expense api
export const addExpense = async (data: any) => {
  try {
    const response = await API.post(`/backend/expense`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllExpense = async (page: any) => {
  try {
    const response = await API.get("/backend/expense", {
      params: {
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllExpenseForAmounts = async (page: any, all: boolean, search?: string, month?: string) => {
  try {
    const response = await API.get("/backend/expense", {
      params: {
        page: page,
        all: all,
        ...(search ? { search } : {}),
        ...(month ? { month } : {}),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateExpense = async (id: string, data: any) => {
  try {
    const response = await API.put(`/backend/expense/${id}/update`, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Update failed";
  }
};

export const getExpenseByID = async (id: any) => {
  try {
    const response = await API.get(`/backend/expense/${id}/edit`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteExpense = async (id: any) => {
  try {
    const response = await API.delete(`/backend/expense/${id}/delete`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const exportExpenseExcel = (params: {
  month?: string;
  method?: string;
  search?: string;
}) => {
  return API.get("/backend/expense/export/excel", {
    params,
    responseType: "blob", // 🔴 IMPORTANT
  });
};

// non-admin user
export const userUpdateFCM = async (id: string, fcmToken: string) => {
  try {
    const response = await API.put(
      `/backend/notifications/${id}/token-update`,
      { fcmToken },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Email Templates
export const fetchEmailTemplates = async (search = "") => {
  const response = await API.get("/email-templates/get-all", {
    params: { search },
  });
  return response.data;
};

export const addEmailTemplate = async (data: any) => {
  const response = await API.post("/email-templates/add", data);
  return response.data;
};

export const updateEmailTemplate = async (id: string, data: any) => {
  const response = await API.put(`/email-templates/update/${id}`, data);
  return response.data;
};

export const deleteEmailTemplate = async (id: string) => {
  const response = await API.delete(`/email-templates/delete/${id}`);
  return response.data;
};

export const getEmailMetadata = async () => {
  const response = await API.get("/email-templates/metadata");
  return response.data;
};

export const getDynamicTags = (params?: any) => {
  return API.get("/email-templates/dynamic-tags", { params });
};

export const getTableColumns = () => API.get("/email-templates/table-columns");

export const getEmailTemplateBySlug = async (slug: string) => {
  const response = await API.get(`/email-templates/get-by-slug/${slug}`);
  return response.data;
};

export const getEmailTemplateById = async (id: string) => {
  const response = await API.get(`/email-templates/${id}`);
  return response.data;
};

// Notification Rules API
export const getnotificationrules = async () => {
  try {
    const response = await API.get("/backend/notifications/rule");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createnotificationrule = async (data: {
  moduleName: string;
  selectedEvents: string[];
}) => {
  try {
    const response = await API.post("/backend/notifications", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatenotificationrule = async (id: string, data: {
  moduleName: string;
  selectedEvents: string[];
}) => {
  try {
    const response = await API.put(`/backend/notifications/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletenotificationrule = async (id: string) => {
  try {
    const response = await API.delete(`/backend/notifications/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const getDiaryByID = async (projectId: any) => {
//   try {
//     const response = await API.get(`/backend/diary/${projectId}`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getAiSettings = async (params?: { search?: string; page?: number; limit?: number; onlyActive?: boolean }) => {
  try {
    const response = await API.get("/backend/ai-settings", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAiSetting = async (data: {
  title: string;
  apiKey: string;
  model: string;
  provider: string;
  apiBase?: string;
  systemPrompt?: string;
  isActive?: boolean;
}) => {
  try {
    const response = await API.post("/backend/ai-settings", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAiSetting = async (id: string, data: {
  title?: string;
  apiKey?: string;
  model?: string;
  provider?: string;
  apiBase?: string;
  systemPrompt?: string;
  isActive?: boolean;
}) => {
  try {
    const response = await API.put(`/backend/ai-settings/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAiSetting = async (id: string) => {
  try {
    const response = await API.delete(`/backend/ai-settings/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Agentic Chatbot APIs ─────────────────────────────────────────────────

/** Upload a file to the chatbot for AI context extraction */
export const uploadChatFile = async (formData: FormData) => {
  try {
    // Let axios set Content-Type automatically — it must include the
    // multipart boundary or multer cannot parse the body (req.file = undefined).
    const response = await API.post("/chat/upload", formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Undo a performed action within the undo window */
export const undoAction = async (actionLogId: string) => {
  try {
    const response = await API.post(`/chat/undo/${actionLogId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Confirm or cancel a hard-confirmation pending action */
export const confirmAction = async (data: {
  pendingActionId: string;
  confirmed: boolean;
  conversationId?: string;
  aiSettingId?: string;
}) => {
  try {
    const response = await API.post("/chat/confirm", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Get action logs (admin or own) */
export const getActionLogs = async (params?: {
  userId?: string;
  collection?: string;
  hours?: number;
}) => {
  try {
    const response = await API.get("/chat/action-logs", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Get chat memories for the current user */
export const getChatMemories = async (params?: {
  layer?: string;
}) => {
  try {
    const response = await API.get("/chat/memories", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Create or update a chat memory */
export const createChatMemory = async (data: {
  key: string;
  value: string;
  layer: string;
  category?: string;
}) => {
  try {
    const response = await API.post("/chat/memories", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Delete a chat memory */
export const deleteChatMemory = async (id: string) => {
  try {
    const response = await API.delete(`/chat/memories/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Get trust scores for the current user */
export const getTrustScores = async () => {
  try {
    const response = await API.get("/chat/trust-scores");
    return response.data;
  } catch (error) {
    throw error;
  }
};
